import React from 'react';

function Topbar() {
  return (
    <div className="container-fluid bg-dark text-white-50 py-2 px-0 d-none d-lg-block">
      <div className="row gx-0 align-items-center">
        <div className="col-lg-7 px-5 text-start">
          <div className="h-100 d-inline-flex align-items-center me-4">
            <small className="fa fa-phone-alt me-2"></small>
            <small>+56 9 45474366</small>
          </div>
          <div className="h-100 d-inline-flex align-items-center me-4">
            <small className="far fa-envelope-open me-2"></small>
            <small>contacto@tamaservice.cl</small>
          </div>
        </div>
       
      </div>
    </div>
  );
}

export default Topbar;